// extracted by mini-css-extract-plugin
export default {"stack":"rAgqhp2Q1F8SeRc0NYMf","fadeIn":"jdPFvKBul4d1jIz_9q0h"};